import React from 'react'

import HeaderMeta from 'components/HeaderMeta'

import Content from 'components/base/Content'
import Title from 'components/base/Title'
import Paragraph, { Theme as ParagraphTheme } from 'components/base/Paragraph'

import PageHero, { Theme as PageHeroTheme }  from 'components/blocks/PageHero'
import Leadership from 'components/blocks/Leadership'
import OurStory from 'components/blocks/OurStory'
import FeaturedNews from 'components/blocks/FeaturedNews'

import Connect from 'components/blocks/Connect'

const PressScreen: React.FC = (): React.ReactElement => (
  <div>
    <HeaderMeta
      title='Recent Press Releases | Insurance Lounge'
      description='Check out recent articles and interviews featuring Insurance Lounge to learn more about us and our mission of providing unparalleled insurance options.'
      ogImg='/images/og-images/Press.webp'
    />
    <PageHero theme={PageHeroTheme.press}>Press Center</PageHero>
    <Content margined={true}>
      <Paragraph theme={ParagraphTheme.introLarge}>
        Welcome to the Insurance Lounge Press Center. In this section you can
        gather assets for news stories.
      </Paragraph>
      <Content short={true} center={true}>
        <Title level={2}>Press Contacts</Title>
        <Paragraph>
          Send questions to
          <br />
          <a className='link-black' href='mailto:media@insurancelounge.com'>
            media@insurancelounge.com
          </a>
        </Paragraph>
      </Content>
    </Content>
    <OurStory />
    <Leadership />
    <FeaturedNews />
    <Connect
      trackingInfo={{
        button_position: 'bottom',
        page_category: 'about_us',
      }}
    />
  </div>
)

export default PressScreen
